import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix, isEqual } from '@antv/util';
import { groups, max, sum } from 'd3-array';
import { format } from 'd3-format';
import { DisplayObject, Text } from '@antv/g';
import { getPolarOptions, getRadialOptions } from '../coordinate';
import { combine } from '../utils/array';
import { capitalizeFirst, defined, subObject } from '../utils/helper';
import { LEGEND_INFER_STRATEGIES } from '../component/constant';
import { coordOf, isHelix, isParallel, isPolar, isRadar, isRadial, isReflect, isReflectY, isTheta, isTranspose } from './coordinate';
import { useLibrary } from './library';
import { isValidScale } from './scale';
import { ConstantScale, ContinuousScale, DiscreteScale, DistributionScale } from './types/scale';
export function inferComponent(scales, partialOptions, library) {
  var _partialOptions$coord = partialOptions.coordinates,
    coordinates = _partialOptions$coord === void 0 ? [] : _partialOptions$coord,
    title = partialOptions.title;
  var _useLibrary = useLibrary('component', library),
    _useLibrary2 = _slicedToArray(_useLibrary, 2),
    createGuideComponent = _useLibrary2[1];
  var displayedScales = scales.filter(function (_ref) {
    var guide = _ref.guide;
    if (guide === null) return false;
    return true;
  });
  var components = [];
  // Sliders and scrollbar component.
  var sliders = inferScrollableComponents(partialOptions, scales, library);
  components.push.apply(components, _toConsumableArray(sliders));
  // Title components.
  if (title) {
    var _createGuideComponent = createGuideComponent('title'),
      props = _createGuideComponent.props;
    var defaultPosition = props.defaultPosition,
      defaultOrientation = props.defaultOrientation,
      defaultOrder = props.defaultOrder,
      defaultSize = props.defaultSize,
      defaultCrossPadding = props.defaultCrossPadding;
    var titleOptions = typeof title === 'string' ? {
      title: title
    } : title;
    components.push(Object.assign({
      type: 'title',
      position: defaultPosition,
      orientation: defaultOrientation,
      order: defaultOrder,
      crossPadding: defaultCrossPadding[0],
      defaultSize: defaultSize
    }, titleOptions));
  }
  // Axis and legends.
  var inferredComponents = inferComponentsType(displayedScales, coordinates);
  inferredComponents.forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      type = _ref3[0],
      relativeScales = _ref3[1];
    var _createGuideComponent2 = createGuideComponent(type),
      props = _createGuideComponent2.props;
    var defaultPosition = props.defaultPosition,
      _props$defaultPlane = props.defaultPlane,
      defaultPlane = _props$defaultPlane === void 0 ? 'xy' : _props$defaultPlane,
      defaultOrientation = props.defaultOrientation,
      defaultSize = props.defaultSize,
      defaultOrder = props.defaultOrder,
      defaultLength = props.defaultLength,
      _props$defaultPadding = props.defaultPadding,
      DP = _props$defaultPadding === void 0 ? [0, 0] : _props$defaultPadding,
      _props$defaultCrossPa = props.defaultCrossPadding,
      DCP = _props$defaultCrossPa === void 0 ? [0, 0] : _props$defaultCrossPa; // @todo to be confirm if the scale can be merged.
    // const scale: G2ScaleOptions = Object.assign({}, ...relativeScales);
    var scale = deepMix.apply(void 0, [{}].concat(_toConsumableArray(relativeScales)));
    var guideOptions = scale.guide,
      field = scale.field; // A scale may have multiple guides.
    var guides = Array.isArray(guideOptions) ? guideOptions : [guideOptions];
    var _iterator = _createForOfIteratorHelper(guides),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var partialGuide = _step.value;
        var _inferComponentPositi = inferComponentPositionAndOrientation(type, defaultPosition, defaultOrientation, partialGuide, relativeScales, displayedScales, coordinates),
          _inferComponentPositi2 = _slicedToArray(_inferComponentPositi, 2),
          position = _inferComponentPositi2[0],
          orientation = _inferComponentPositi2[1]; // Skip if position and orientation are not specified.
        // @example the last axis of radar chart
        if (!position && !orientation) continue;
        var isVertical = position === 'left' || position === 'right';
        var defaultPadding = isVertical ? DP[1] : DP[0];
        var _defaultCrossPadding = isVertical ? DCP[1] : DCP[0];
        var size = partialGuide.size,
          _partialGuide$order = partialGuide.order,
          order = _partialGuide$order === void 0 ? defaultOrder : _partialGuide$order,
          _partialGuide$length = partialGuide.length,
          length = _partialGuide$length === void 0 ? defaultLength : _partialGuide$length,
          _partialGuide$padding = partialGuide.padding,
          padding = _partialGuide$padding === void 0 ? defaultPadding : _partialGuide$padding,
          _partialGuide$crossPa = partialGuide.crossPadding,
          crossPadding = _partialGuide$crossPa === void 0 ? _defaultCrossPadding : _partialGuide$crossPa;
        components.push(Object.assign(Object.assign({
          title: field
        }, partialGuide), {
          defaultSize: defaultSize,
          length: length,
          position: position,
          plane: defaultPlane,
          orientation: orientation,
          padding: padding,
          order: order,
          crossPadding: crossPadding,
          size: size,
          type: type,
          scales: relativeScales
        }));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  return components;
}
export function renderComponent(component, coordinate, theme, library, markState) {
  var _useLibrary3 = useLibrary('component', library),
    _useLibrary4 = _slicedToArray(_useLibrary3, 1),
    useGuideComponent = _useLibrary4[0];
  var scales = component.scaleInstances,
    scale = component.scale,
    bbox = component.bbox,
    options = __rest(component, ["scaleInstances", "scale", "bbox"]);
  var value = {
    bbox: bbox,
    library: library
  };
  var render = useGuideComponent(options);
  return render({
    coordinate: coordinate,
    library: library,
    markState: markState,
    scales: scales,
    theme: theme,
    value: value,
    scale: scale
  });
}
export function normalizeComponents(components) {
  return components.map(function (d) {
    var component = deepMix(d, d.style);
    delete component.style;
    return component;
  });
}
export function flatComponents(components) {
  return components.flatMap(function (d) {
    return d.type == 'group' ? d.children : d;
  });
}
// Wrap legends into a group component.
export function groupComponents(components, crossSize) {
  // Group components by key.
  var P = ['left', 'right', 'bottom', 'top'];
  var key = function key(_ref4) {
    var type = _ref4.type,
      position = _ref4.position,
      group = _ref4.group;
    if (!P.includes(position)) return Symbol('independent');
    if (group === undefined) {
      if (type.startsWith('legend')) return "legend-".concat(position);
      return Symbol('independent');
    }
    if (group === 'independent') return Symbol('independent');
    return group;
  };
  var grouped = groups(components, key);
  // Update attributes of group components,
  // and maybe flatten group components without enough room.
  return grouped.flatMap(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      components = _ref6[1];
    if (components.length === 1) return components[0];
    // If crossSize defined, group components only when has
    // enough room.
    if (crossSize !== undefined) {
      // Compute total length.
      var DL = components.filter(function (d) {
        return d.length !== undefined;
      }).map(function (d) {
        return d.length;
      });
      var totalLength = sum(DL);
      // If there is no enough room for components,
      // do not group.
      if (totalLength > crossSize) {
        components.forEach(function (d) {
          return d.group = Symbol('independent');
        });
        return components;
      }
      // Group legends and update legend length.
      var emptyLength = crossSize - totalLength;
      var emptyCount = components.length - DL.length;
      var length = emptyLength / emptyCount;
      components.forEach(function (d) {
        if (d.length !== undefined) return;
        d.length = length;
      });
    }
    // Create a group component.
    var size = max(components, function (d) {
      return d.size;
    });
    var order = max(components, function (d) {
      return d.order;
    });
    var crossPadding = max(components, function (d) {
      return d.crossPadding;
    });
    var position = components[0].position;
    return {
      type: 'group',
      size: size,
      order: order,
      position: position,
      children: components,
      crossPadding: crossPadding
    };
  });
}
function inferLegendComponentType(scales, coordinates) {
  // Filter accepts scales.
  var channels = ['shape', 'size', 'color', 'opacity'];
  var isConstantSize = function isConstantSize(type, name) {
    return type === 'constant' && name === 'size';
  };
  var accepts = scales.filter(function (_ref7) {
    var type = _ref7.type,
      name = _ref7.name;
    return typeof type === 'string' && channels.includes(name) && !isConstantSize(type, name);
  });
  // Group scales by fields.
  var constants = accepts.filter(function (_ref8) {
    var type = _ref8.type;
    return type === 'constant';
  });
  var nonConstants = accepts.filter(function (_ref9) {
    var type = _ref9.type;
    return type !== 'constant';
  });
  var groupKey = function groupKey(d) {
    return d.field ? d.field : Symbol('independent');
  };
  var fieldScales = groups(nonConstants, groupKey).map(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
      key = _ref11[0],
      scales = _ref11[1];
    return [key, [].concat(_toConsumableArray(scales), _toConsumableArray(constants))];
  }).filter(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
      scales = _ref13[1];
    return scales.some(function (scale) {
      return scale.type !== 'constant';
    });
  });
  var scalesByField = new Map(fieldScales);
  // Skip empty scales.
  if (scalesByField.size === 0) return [];
  // Infer components.
  var sort = function sort(arr) {
    return arr.sort(function (_ref14, _ref15) {
      var _ref16 = _slicedToArray(_ref14, 1),
        a = _ref16[0];
      var _ref17 = _slicedToArray(_ref15, 1),
        b = _ref17[0];
      return a.localeCompare(b);
    });
  };
  var components = Array.from(scalesByField).map(function (_ref18) {
    var _ref19 = _slicedToArray(_ref18, 2),
      scs = _ref19[1];
    var combinations = combine(scs).sort(function (a, b) {
      return b.length - a.length;
    });
    var options = combinations.map(function (combination) {
      return {
        combination: combination,
        option: combination.map(function (scale) {
          return [scale.name, getScaleType(scale)];
        })
      };
    });
    // For category legend.
    var _iterator2 = _createForOfIteratorHelper(options),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _step2.value,
          option = _step2$value.option,
          combination = _step2$value.combination;
        // If every scale is constant, do not display legend.
        if (option.every(function (d) {
          return d[1] === 'constant';
        })) continue;
        if (option.every(function (d) {
          return d[1] === 'discrete' || d[1] === 'constant';
        })) {
          return ['legendCategory', combination];
        }
      }
      // For reset legend.
      // @todo Remove this.
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var _iterator3 = _createForOfIteratorHelper(LEGEND_INFER_STRATEGIES),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
          componentType = _step3$value[0],
          accords = _step3$value[1];
        var _iterator4 = _createForOfIteratorHelper(options),
          _step4;
        try {
          var _loop = function _loop() {
              var _step4$value = _step4.value,
                option = _step4$value.option,
                combination = _step4$value.combination;
              if (accords.some(function (accord) {
                return isEqual(sort(accord), sort(option));
              })) {
                return {
                  v: [componentType, combination]
                };
              }
            },
            _ret;
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            _ret = _loop();
            if (_ret) return _ret.v;
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return null;
  }).filter(defined);
  return components;
}
function getScaleType(scale) {
  var type = scale.type;
  if (typeof type !== 'string') return null;
  if (type in ContinuousScale) return 'continuous';
  if (type in DiscreteScale) return 'discrete';
  if (type in DistributionScale) return 'distribution';
  if (type in ConstantScale) return 'constant';
  return null;
}
function inferAxisComponentType(scales, coordinates) {
  return scales.map(function (scale) {
    var name = scale.name; // todo wait for gui provide helix axis
    if (isHelix(coordinates) || isTheta(coordinates)) return null;
    if (isTranspose(coordinates) && (isPolar(coordinates) || isRadial(coordinates))) return null;
    // infer axis
    if (name.startsWith('x')) {
      if (isPolar(coordinates)) return ['axisArc', [scale]];
      if (isRadial(coordinates)) return ['axisLinear', [scale]];
      return [isTranspose(coordinates) ? 'axisY' : 'axisX', [scale]];
    }
    if (name.startsWith('y')) {
      if (isPolar(coordinates)) return ['axisLinear', [scale]];
      if (isRadial(coordinates)) return ['axisArc', [scale]];
      return [isTranspose(coordinates) ? 'axisX' : 'axisY', [scale]];
    }
    // Only support linear axis for z.
    if (name.startsWith('z')) {
      return ['axisZ', [scale]];
    }
    if (name.startsWith('position')) {
      if (isRadar(coordinates)) return ['axisRadar', [scale]];
      if (!isPolar(coordinates)) return ['axisY', [scale]];
    }
    return null;
  }).filter(defined);
}
function inferComponentsType(scales, coordinates) {
  var availableScales = scales.filter(function (scale) {
    return isValidScale(scale);
  });
  return [].concat(_toConsumableArray(inferLegendComponentType(availableScales, coordinates)), _toConsumableArray(inferAxisComponentType(availableScales, coordinates)));
}
function angleOf(coordinates) {
  var polar = coordOf(coordinates, 'polar');
  if (polar.length) {
    var lastPolar = polar[polar.length - 1];
    var _getPolarOptions = getPolarOptions(lastPolar),
      startAngle = _getPolarOptions.startAngle,
      endAngle = _getPolarOptions.endAngle;
    return [startAngle, endAngle];
  }
  var radial = coordOf(coordinates, 'radial');
  if (radial.length) {
    var lastRadial = radial[radial.length - 1];
    var _getRadialOptions = getRadialOptions(lastRadial),
      _startAngle = _getRadialOptions.startAngle,
      _endAngle = _getRadialOptions.endAngle;
    return [_startAngle, _endAngle];
  }
  return [-Math.PI / 2, Math.PI / 2 * 3];
}
/**
 * match index of position
 */
function matchPosition(name) {
  var match = /position(\d*)/g.exec(name);
  if (!match) return null;
  return +match[1];
}
function inferAxisPositionAndOrientation(type, ordinalPosition, relativeScales, scales, coordinates) {
  // a axis only has one scale
  var name = relativeScales[0].name; // todo, in current resolution, the radar chart is implement by parallel + polar coordinate.
  // implementation plan to be confirmed.
  // in current implementation, it must to add the first position encode to it's last.
  // so we won't render the last axis repeatably.
  if (type === 'axisRadar') {
    var positions = scales.filter(function (scale) {
      return scale.name.startsWith('position');
    });
    var index = matchPosition(name);
    if (name === positions.slice(-1)[0].name || index === null) return [null, null];
    // infer radar axis orientation
    var _angleOf = angleOf(coordinates),
      _angleOf2 = _slicedToArray(_angleOf, 2),
      startAngle = _angleOf2[0],
      endAngle = _angleOf2[1];
    var angle = (endAngle - startAngle) / (positions.length - 1) * index + startAngle;
    return ['center', angle];
  }
  if (type === 'axisY' && isParallel(coordinates)) {
    return isTranspose(coordinates) ? ['center', 'horizontal'] : ['center', 'vertical'];
  }
  // in non-cartesian coordinate systems, infer the arc axis angle
  if (type === 'axisLinear') {
    var _angleOf3 = angleOf(coordinates),
      _angleOf4 = _slicedToArray(_angleOf3, 1),
      _startAngle2 = _angleOf4[0];
    return ['center', _startAngle2];
  }
  if (type === 'axisArc') {
    if (ordinalPosition[0] === 'inner') return ['inner', null];
    return ['outer', null];
  }
  if (isPolar(coordinates)) return ['center', null];
  if (isRadial(coordinates)) return ['center', null];
  if (type === 'axisX' && isReflect(coordinates) || type === 'axisX' && isReflectY(coordinates)) {
    return ['top', null];
  }
  // if (type === 'axisX') return ['bottom', null];
  return ordinalPosition;
}
// @todo Infer position by coordinates.
function inferComponentPositionAndOrientation(type, defaultPosition, defaultOrientation, guide, relativeScales, scales, coordinates) {
  var _angleOf5 = angleOf(coordinates),
    _angleOf6 = _slicedToArray(_angleOf5, 1),
    startAngle = _angleOf6[0];
  var ordinalPositionAndOrientation = [guide.position || defaultPosition, startAngle !== null && startAngle !== void 0 ? startAngle : defaultOrientation];
  if (typeof type === 'string' && type.startsWith('axis')) {
    return inferAxisPositionAndOrientation(type, ordinalPositionAndOrientation, relativeScales, scales, coordinates);
  }
  if (typeof type === 'string' && type.startsWith('legend') && isPolar(coordinates)) {
    if (guide.position === 'center') return ['center', 'vertical'];
  }
  // for general component, use default position
  return ordinalPositionAndOrientation;
}
function inferScrollableType(name, type) {
  var coordinates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (name === 'x') return isTranspose(coordinates) ? "".concat(type, "Y") : "".concat(type, "X");
  if (name === 'y') return isTranspose(coordinates) ? "".concat(type, "X") : "".concat(type, "Y");
  return null;
}
/**
 * Infer scrollable components, such as slider and scrollbar.
 */
function inferScrollableComponents(partialOptions, scales, library) {
  var _useLibrary5 = useLibrary('component', library),
    _useLibrary6 = _slicedToArray(_useLibrary5, 2),
    createGuideComponent = _useLibrary6[1];
  var coordinates = partialOptions.coordinates;
  function normalized(type, channelName, scale, options) {
    var componentType = inferScrollableType(channelName, type, coordinates);
    if (!options || !componentType) return;
    var _createGuideComponent3 = createGuideComponent(componentType),
      props = _createGuideComponent3.props;
    var defaultPosition = props.defaultPosition,
      defaultSize = props.defaultSize,
      defaultOrder = props.defaultOrder,
      _props$defaultCrossPa2 = _slicedToArray(props.defaultCrossPadding, 1),
      crossPadding = _props$defaultCrossPa2[0];
    return Object.assign(Object.assign({
      position: defaultPosition,
      defaultSize: defaultSize,
      order: defaultOrder,
      type: componentType,
      crossPadding: crossPadding
    }, options), {
      scales: [scale]
    });
  }
  return scales.filter(function (d) {
    return d.slider || d.scrollbar;
  }).flatMap(function (scale) {
    var slider = scale.slider,
      scrollbar = scale.scrollbar,
      channelName = scale.name;
    return [normalized('slider', channelName, scale, slider), normalized('scrollbar', channelName, scale, scrollbar)];
  }).filter(function (d) {
    return !!d;
  });
}
// !!! Note Mutate component.size and component.
export function computeComponentSize(component, crossSize, crossPadding, position, theme, library) {
  // Only compute and update size of components in padding area.
  var type = component.type;
  var paddingAreas = ['left', 'right', 'bottom', 'top'];
  if (!paddingAreas.includes(position)) return;
  if (typeof type !== 'string') return;
  var t = type;
  var createCompute = function createCompute() {
    if (t.startsWith('axis')) return computeAxisSize;
    if (t.startsWith('group')) return computeGroupSize;
    if (t.startsWith('legendContinuous')) return computeContinuousLegendSize;
    if (t === 'legendCategory') return computeCategoryLegendSize;
    if (t.startsWith('slider')) return computeSliderSize;
    if (t === 'title') return computeTitleSize;
    if (t.startsWith('scrollbar')) return computeScrollbarSize;
    return function () {};
  };
  return createCompute()(component, crossSize, crossPadding, position, theme, library);
}
function computeGroupSize(component, crossSize, crossPadding, position, theme, library) {
  var children = component.children;
  var maxCrossPadding = max(children, function (d) {
    return d.crossPadding;
  });
  children.forEach(function (d) {
    return d.crossPadding = maxCrossPadding;
  });
  children.forEach(function (child) {
    return computeComponentSize(child, crossSize, crossPadding, position, theme, library);
  });
  var maxSize = max(children, function (d) {
    return d.size;
  });
  component.size = maxSize;
  children.forEach(function (d) {
    return d.size = maxSize;
  });
}
function computeScrollbarSize(component, crossSize, crossPadding, position, theme, library) {
  var _deepMix = deepMix({}, theme.scrollbar, component),
    _deepMix$trackSize = _deepMix.trackSize,
    trackSize = _deepMix$trackSize === void 0 ? 6 : _deepMix$trackSize;
  component.size = trackSize;
}
function computeTitleSize(component, crossSize, crossPadding, position, theme, library) {
  var _a = deepMix({}, theme.title, component),
    title = _a.title,
    subtitle = _a.subtitle,
    _a$spacing = _a.spacing,
    spacing = _a$spacing === void 0 ? 0 : _a$spacing,
    style = __rest(_a, ["title", "subtitle", "spacing"]);
  if (title) {
    var titleStyle = subObject(style, 'title');
    var titleBBox = computeLabelSize(title, titleStyle);
    component.size = titleBBox.height;
  }
  if (subtitle) {
    var subtitleStyle = subObject(style, 'subtitle');
    var subtitleBBox = computeLabelSize(subtitle, subtitleStyle);
    component.size += spacing + subtitleBBox.height;
  }
}
function computeSliderSize(component, crossSize, crossPadding, position, theme, library) {
  var styleOf = function styleOf() {
    var slider = theme.slider;
    return deepMix({}, slider, component);
  };
  var _styleOf = styleOf(),
    trackSize = _styleOf.trackSize,
    handleIconSize = _styleOf.handleIconSize;
  var size = Math.max(trackSize, handleIconSize * 2.4);
  component.size = size;
}
function computeAxisSize(component, crossSize, crossPadding, position, theme, library) {
  // If padding is auto, use hide as the labelTransform by default
  // to avoid overlap between labels.
  component.transform = component.transform || [{
    type: 'hide'
  }];
  // Vertical or horizontal.
  var isVertical = position === 'left' || position === 'right';
  // Get styles to be applied.
  var style = styleOf(component, position, theme);
  var _style$tickLength = style.tickLength,
    tickLength = _style$tickLength === void 0 ? 0 : _style$tickLength,
    _style$labelSpacing = style.labelSpacing,
    labelSpacing = _style$labelSpacing === void 0 ? 0 : _style$labelSpacing,
    _style$titleSpacing = style.titleSpacing,
    titleSpacing = _style$titleSpacing === void 0 ? 0 : _style$titleSpacing,
    rest = __rest(style, ["tickLength", "labelSpacing", "titleSpacing"]); // Compute Labels.
  var scale = createScale(component, library);
  var labelBBoxes = computeLabelsBBox(rest, scale);
  var paddingTick = tickLength + labelSpacing;
  if (labelBBoxes && labelBBoxes.length) {
    var maxLabelWidth = max(labelBBoxes, function (d) {
      return d.width;
    });
    var maxLabelHeight = max(labelBBoxes, function (d) {
      return d.height;
    });
    if (isVertical) {
      component.size = maxLabelWidth + paddingTick;
    } else {
      var tickFilter = component.tickFilter,
        labelTransform = component.labelTransform; // If the labels can't be placed horizontally, and labelTransform is unset,
      // rotate 90 deg to display them.
      if (overflowX(scale, labelBBoxes, crossSize, crossPadding, tickFilter) && !labelTransform) {
        component.labelTransform = 'rotate(90)';
        component.size = maxLabelWidth + paddingTick;
      } else {
        component.size = maxLabelHeight + paddingTick;
      }
    }
  } else {
    component.size = tickLength;
  }
  // Compute title.
  var titleBBox = computeTitleBBox(rest);
  if (titleBBox) {
    if (isVertical) {
      component.size += titleSpacing + titleBBox.width;
    } else {
      component.size += titleSpacing + titleBBox.height;
    }
  }
}
function computeContinuousLegendSize(component, crossSize, crossPadding, position, theme, library) {
  // Get styles.
  var styleOf = function styleOf() {
    var legendContinuous = theme.legendContinuous;
    return deepMix({}, legendContinuous, component);
  };
  var _a = styleOf(),
    _a$labelSpacing = _a.labelSpacing,
    labelSpacing = _a$labelSpacing === void 0 ? 0 : _a$labelSpacing,
    _a$titleSpacing = _a.titleSpacing,
    titleSpacing = _a$titleSpacing === void 0 ? 0 : _a$titleSpacing,
    rest = __rest(_a, ["labelSpacing", "titleSpacing"]);
  // Vertical or horizontal.
  var isVertical = position === 'left' || position === 'right';
  // Ribbon styles.
  var ribbonStyles = subObject(rest, 'ribbon');
  var ribbonSize = ribbonStyles.size;
  var handleIconStyles = subObject(rest, 'handleIcon');
  var handleIconSize = handleIconStyles.size;
  var mainSize = Math.max(ribbonSize, handleIconSize * 2.4);
  component.size = mainSize;
  // Compute labels.
  var scale = createScale(component, library);
  var labelBBoxes = computeLabelsBBox(rest, scale);
  if (labelBBoxes) {
    var key = isVertical ? 'width' : 'height';
    var size = max(labelBBoxes, function (d) {
      return d[key];
    });
    component.size += size + labelSpacing;
  }
  // Compute title.
  var titleBBox = computeTitleBBox(rest);
  if (titleBBox) {
    if (isVertical) {
      component.size = Math.max(component.size, titleBBox.width);
    } else {
      component.size += titleSpacing + titleBBox.height;
    }
  }
}
function computeCategoryLegendSize(component, crossSize0, crossPadding, position, theme, library) {
  var styleOf = function styleOf() {
    var legendCategory = theme.legendCategory;
    var title = component.title;
    var _ref20 = Array.isArray(title) ? [title, undefined] : [undefined, title],
      _ref21 = _slicedToArray(_ref20, 2),
      defaultTitle = _ref21[0],
      specifiedTitle = _ref21[1];
    return deepMix({
      title: defaultTitle
    }, legendCategory, Object.assign(Object.assign({}, component), {
      title: specifiedTitle
    }));
  };
  var _a = styleOf(),
    itemSpacing = _a.itemSpacing,
    itemMarkerSize = _a.itemMarkerSize,
    titleSpacing = _a.titleSpacing,
    rowPadding = _a.rowPadding,
    colPadding = _a.colPadding,
    _a$maxCols = _a.maxCols,
    maxCols = _a$maxCols === void 0 ? Infinity : _a$maxCols,
    _a$maxRows = _a.maxRows,
    maxRows = _a$maxRows === void 0 ? Infinity : _a$maxRows,
    rest = __rest(_a, ["itemSpacing", "itemMarkerSize", "titleSpacing", "rowPadding", "colPadding", "maxCols", "maxRows"]);
  var cols = component.cols,
    length = component.length;
  var getRows = function getRows(rows) {
    return Math.min(rows, maxRows);
  };
  var getCols = function getCols(cols) {
    return Math.min(cols, maxCols);
  };
  // Vertical or horizontal.
  var isVertical = position === 'left' || position === 'right';
  var crossSize = length === undefined ? crossSize0 + (isVertical ? 0 : crossPadding[0] + crossPadding[1]) : length;
  // Compute title.
  var titleBBox = computeTitleBBox(rest);
  var scale = createScale(component, library);
  var labelBBoxes = computeLabelsBBox(rest, scale, 'itemLabel');
  var height = Math.max(labelBBoxes[0].height, itemMarkerSize) + rowPadding;
  var widthOf = function widthOf(w) {
    var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return itemMarkerSize + w + itemSpacing[0] + padding;
  };
  // Only support grid layout for vertical area.
  var computeVerticalSize = function computeVerticalSize() {
    var maxSize = -Infinity;
    var pos = 0;
    var cols = 1;
    var rows = 0;
    var maxRows = -Infinity;
    var maxPos = -Infinity;
    var titleHeight = titleBBox ? titleBBox.height : 0;
    var maxHeight = crossSize - titleHeight;
    var _iterator5 = _createForOfIteratorHelper(labelBBoxes),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var width = _step5.value.width;
        var w = widthOf(width);
        maxSize = Math.max(maxSize, w);
        if (pos + height > maxHeight) {
          cols++;
          maxRows = Math.max(maxRows, rows);
          maxPos = Math.max(maxPos, pos);
          rows = 1;
          pos = height;
        } else {
          pos += height;
          rows++;
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
    if (cols <= 1) {
      maxRows = rows;
      maxPos = pos;
    }
    component.size = maxSize * getCols(cols);
    component.length = maxPos + titleHeight;
    deepMix(component, {
      cols: getCols(cols),
      gridRow: maxRows
    });
  };
  // Horizontal grid layout.
  var computeHorizontalGrid = function computeHorizontalGrid() {
    var rows = Math.ceil(labelBBoxes.length / cols);
    var maxWidth = max(labelBBoxes, function (d) {
      return widthOf(d.width);
    }) * cols;
    component.size = height * getRows(rows) - rowPadding;
    component.length = Math.min(maxWidth, crossSize);
  };
  // Horizontal flex layout.
  var computeHorizontalFlex = function computeHorizontalFlex() {
    var rows = 1;
    var pos = 0;
    var maxPos = -Infinity;
    var _iterator6 = _createForOfIteratorHelper(labelBBoxes),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var width = _step6.value.width;
        var w = widthOf(width, colPadding);
        if (pos + w > crossSize) {
          maxPos = Math.max(maxPos, pos);
          pos = w;
          rows++;
        } else {
          pos += w;
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    if (rows === 1) maxPos = pos;
    component.size = height * getRows(rows) - rowPadding;
    component.length = maxPos;
  };
  if (isVertical) computeVerticalSize();else if (typeof cols === 'number') computeHorizontalGrid();else computeHorizontalFlex();
  // Compute titles.
  if (titleBBox) {
    if (isVertical) {
      component.size = Math.max(component.size, titleBBox.width);
    } else {
      component.size += titleSpacing + titleBBox.height;
    }
  }
}
export function createScale(component, library) {
  var _useLibrary7 = useLibrary('scale', library),
    _useLibrary8 = _slicedToArray(_useLibrary7, 1),
    useScale = _useLibrary8[0]; // Init scale, the tickCount of axis has higher priority than scale.
  var scales = component.scales,
    tickCount = component.tickCount,
    tickMethod = component.tickMethod;
  var scaleOptions = scales.find(function (d) {
    return d.type !== 'constant' && d.type !== 'identity';
  });
  if (tickCount !== undefined) scaleOptions.tickCount = tickCount;
  if (tickMethod !== undefined) scaleOptions.tickMethod = tickMethod;
  return useScale(scaleOptions);
}
export function computeLabelsBBox(component, scale) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'label';
  var labelFormatter = component.labelFormatter,
    tickFilter = component.tickFilter,
    _component$label = component.label,
    label = _component$label === void 0 ? true : _component$label,
    style = __rest(component, ["labelFormatter", "tickFilter", "label"]);
  if (!label) return null;
  // Get labels to be rendered.
  var labels = labelsOf(scale, labelFormatter, tickFilter);
  var labelStyle = subObject(style, key);
  var labelStyles = labels.map(function (d, i) {
    return Object.fromEntries(Object.entries(labelStyle).map(function (_ref22) {
      var _ref23 = _slicedToArray(_ref22, 2),
        key = _ref23[0],
        value = _ref23[1];
      return [key, typeof value === 'function' ? value(d, i) : value];
    }));
  });
  var labelBBoxes = labels.map(function (d, i) {
    var normalizeStyle = labelStyles[i];
    return computeLabelSize(d, normalizeStyle);
  });
  // Cache boxes to avoid computed twice.
  // @todo GUI use untransformed bbox, so it can't cache if
  // label.style has transform attributes.
  var hasTransform = labelStyles.some(function (d) {
    return d.transform;
  });
  if (!hasTransform) {
    var I = labels.map(function (_, i) {
      return i;
    });
    component.indexBBox = new Map(I.map(function (i) {
      return [i, [labels[i], labelBBoxes[i]]];
    }));
  }
  return labelBBoxes;
}
export function computeTitleBBox(component) {
  var isFalsy = function isFalsy(x) {
    return x === false || x === null;
  };
  var title = component.title,
    style = __rest(component, ["title"]);
  if (isFalsy(title) || title === undefined) return null;
  var titleStyle = subObject(style, 'title');
  var direction = titleStyle.direction,
    transform = titleStyle.transform;
  var titleText = Array.isArray(title) ? title.join(',') : title;
  if (typeof titleText !== 'string') return null;
  var titleBBox = computeLabelSize(titleText, Object.assign(Object.assign({}, titleStyle), {
    transform: transform || (direction === 'vertical' ? 'rotate(-90)' : '')
  }));
  return titleBBox;
}
export function styleOf(axis, position, theme) {
  var title = axis.title;
  var _ref24 = Array.isArray(title) ? [title, undefined] : [undefined, title],
    _ref25 = _slicedToArray(_ref24, 2),
    defaultTitle = _ref25[0],
    specifiedTitle = _ref25[1];
  var baseStyle = theme.axis,
    positionStyle = theme["axis".concat(capitalizeFirst(position))];
  return deepMix({
    title: defaultTitle
  }, baseStyle, positionStyle, Object.assign(Object.assign({}, axis), {
    title: specifiedTitle
  }));
}
function ticksOf(scale, tickFilter) {
  var ticks = scale.getTicks ? scale.getTicks() : scale.getOptions().domain;
  if (!tickFilter) return ticks;
  return ticks.filter(tickFilter);
}
function labelsOf(scale, labelFormatter, tickFilter) {
  var T = ticksOf(scale, tickFilter);
  var ticks = T.map(function (d) {
    return typeof d === 'number' ? prettyNumber(d) : d;
  });
  var formatter = labelFormatter ? typeof labelFormatter === 'string' ? format(labelFormatter) : labelFormatter : scale.getFormatter ? scale.getFormatter() : function (d) {
    return "".concat(d);
  };
  return ticks.map(formatter);
}
function offsetOf(scale, d) {
  if (!scale.getBandWidth) return 0;
  var offset = scale.getBandWidth(d) / 2;
  return offset;
}
function overflowX(scale, labelBBoxes, crossSize, crossPadding, tickFilter) {
  // If actual size bigger than container size, overflow.
  var totalSize = sum(labelBBoxes, function (d) {
    return d.width;
  });
  if (totalSize > crossSize) return true;
  // Clone scale to get visual position for labels.
  var scaleX = scale.clone();
  scaleX.update({
    range: [0, crossSize]
  });
  var ticks = ticksOf(scale, tickFilter);
  var X = ticks.map(function (d) {
    return scaleX.map(d) + offsetOf(scaleX, d);
  });
  var I = ticks.map(function (_, i) {
    return i;
  });
  var startX = -crossPadding[0];
  var endX = crossSize + crossPadding[1];
  var extent = function extent(x, bbox) {
    var width = bbox.width;
    return [x - width / 2, x + width / 2];
  };
  // Collision detection.
  for (var i = 0; i < I.length; i++) {
    var x = X[i];
    var _extent = extent(x, labelBBoxes[i]),
      _extent2 = _slicedToArray(_extent, 2),
      x0 = _extent2[0],
      x1 = _extent2[1]; // If a label is out of plot area, overflow.
    if (x0 < startX || x1 > endX) return true;
    var y = X[i + 1];
    if (y) {
      // If two labels intersect, overflow.
      var _extent3 = extent(y, labelBBoxes[i + 1]),
        _extent4 = _slicedToArray(_extent3, 1),
        y0 = _extent4[0];
      if (x1 > y0) return true;
    }
  }
  return false;
}
function computeLabelSize(d, style) {
  var shape = normalizeLabel(d);
  var filter = style.filter,
    rest = __rest(style, ["filter"]);
  shape.attr(Object.assign(Object.assign({}, rest), {
    visibility: 'none'
  }));
  var bbox = shape.getBBox();
  return bbox;
}
function normalizeLabel(d) {
  if (d instanceof DisplayObject) return d;
  return new Text({
    style: {
      text: "".concat(d)
    }
  });
}
function prettyNumber(n) {
  return Math.abs(n) < 1e-15 ? n : parseFloat(n.toFixed(15));
}